import { MissionData } from '../blocks/mission'
import template from './templates/RJF01.rbxl'
import thumbnail0 from './thumbnails/RJF01/mission.png'
import thumbnail1 from './thumbnails/RJF01/PinkWall.png'
import thumbnail2 from './thumbnails/RJF01/GreenFloor.png'
import thumbnail3 from './thumbnails/RJF01/Switch.png'
import thumbnail4 from './thumbnails/RJF01/BossFloor.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  template,
  thumbnail: thumbnail0,
  title: 'プログラミングのチカラでボスをたおせ！',
  chapters: [
    {
      toolbox: {
        kind: 'categoryToolbox',
        contents: [
          {
            kind: 'category',
            name: '%{BKY_C_MOVEMENT}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'movement',
            contents: [
              {
                kind: 'block',
                type: 'movement_moveSteps',
                inputs: {
                  VAL: { shadow: { type: 'math_number', fields: { NUM: 10 } } },
                },
              },
              { kind: 'block', type: 'movement_unsetCanCollide' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_EVENTS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'events',
            contents: [{ kind: 'block', type: 'events_onPlay' }],
          },
          {
            kind: 'category',
            name: '%{BKY_C_LOOKS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'looks',
            contents: [{ kind: 'block', type: 'looks_seeThrough' }],
          },
        ],
      },
    },
    {
      toolbox: {
        kind: 'categoryToolbox',
        contents: [
          {
            kind: 'category',
            name: '%{BKY_C_MOVEMENT}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'movement',
            contents: [
              {
                kind: 'block',
                type: 'movement_moveSteps',
                inputs: {
                  VAL: { shadow: { type: 'math_number', fields: { NUM: 10 } } },
                },
              },
              { kind: 'block', type: 'movement_unsetCanCollide' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_EVENTS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'events',
            contents: [{ kind: 'block', type: 'events_onPlay' }],
          },
          {
            kind: 'category',
            name: '%{BKY_C_LOOKS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'looks',
            contents: [{ kind: 'block', type: 'looks_seeThrough' }],
          },
        ],
      },
    },
    {
      toolbox: {
        kind: 'categoryToolbox',
        contents: [
          {
            kind: 'category',
            name: '%{BKY_C_MOVEMENT}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'movement',
            contents: [
              {
                kind: 'block',
                type: 'movement_moveSteps',
                inputs: {
                  VAL: { shadow: { type: 'math_number', fields: { NUM: 10 } } },
                },
              },
              { kind: 'block', type: 'movement_unsetCanCollide' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_EVENTS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'events',
            contents: [{ kind: 'block', type: 'events_onPlay' }],
          },
          {
            kind: 'category',
            name: '%{BKY_C_LOOKS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'looks',
            contents: [{ kind: 'block', type: 'looks_seeThrough' }],
          },
        ],
      },
    },
    {
      toolbox: {
        kind: 'categoryToolbox',
        contents: [
          {
            kind: 'category',
            name: '%{BKY_C_EVENTS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'events',
            contents: [
              {
                kind: 'block',
                type: 'events_setWalkSpeedTo',
              },
              { kind: 'block', type: 'events_onTouchCharacter' },
            ],
          },
        ],
      },
    },
    {
      toolbox: {
        kind: 'categoryToolbox',
        contents: [
          {
            kind: 'category',
            name: '%{BKY_C_MOVEMENT}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'movement',
            contents: [
              { kind: 'block', type: 'movement_setCanCollide' },
              { kind: 'block', type: 'movement_unsetCanCollide' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_LOOKS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'looks',
            contents: [
              { kind: 'block', type: 'looks_show' },
              { kind: 'block', type: 'looks_hide' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_EVENTS}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'events',
            contents: [
              {
                kind: 'block',
                type: 'events_onMessage',
                fields: { VAL: 'スイッチ' },
              },
              {
                kind: 'block',
                type: 'events_sendMessage',
                fields: { VAL: 'スイッチ' },
              },
              //  { "kind": "block", "type": "events_onMessage"},
              //  { "kind": "block", "type": "events_sendMessage"},
              { kind: 'block', type: 'events_onTouchCharacter' },
            ],
          },
          {
            kind: 'category',
            name: '%{BKY_C_CONTROL}',
            // @ts-expect-error Missing from definition, but correct. 定義から欠落していますが、正しいです。
            categoryStyle: 'control',
            contents: [
              { kind: 'block', type: 'control_destroy' },
              {
                kind: 'block',
                type: 'control_wait',
                inputs: {
                  VAL: {
                    shadow: {
                      type: 'math_empty_number_empty_string',
                      fields: { VAL: 1 },
                    },
                  },
                },
              },
            ],
          },
        ],
      },
    },
    {},
  ],
  objects: [
    {
      name: '①ピンクのかべ',
      thumbnail: thumbnail1,
    },
    {
      name: '②みどりのゆか',
      thumbnail: thumbnail2,
    },
    {
      name: '③スイッチ',
      thumbnail: thumbnail3,
      workspace: {
        messages: ['スイッチ'],
      },
    },
    {
      name: '④ボスのゆか',
      thumbnail: thumbnail4,
      workspace: {
        messages: ['スイッチ'],
      },
    },
  ],
}

export default mission
